import { useSearchParams } from "react-router-dom";
import type { CreativeLibrarySubjectsProps } from "@/types/creative-library";
import { SubjectManager } from "./SubjectManager";

/** Character management has one URL owner: Creatives, with explicit Brand context. */
export function CreativeLibrarySubjects({
  brands,
  subjects,
  creatives,
  onSaved,
  onUse,
}: CreativeLibrarySubjectsProps) {
  const [params, setParams] = useSearchParams();
  const brand =
    params.get("view") === "creatives" && params.get("models") === "1"
      ? (brands.find((item) => item.token === params.get("brand")) ?? null)
      : null;
  return (
    <SubjectManager
      brand={brand}
      subjects={subjects}
      creatives={creatives}
      initialSubjectToken={params.get("subject") ?? undefined}
      onClose={() =>
        setParams(
          (previous) => {
            const next = new URLSearchParams(previous);
            next.delete("models");
            next.delete("subject");
            return next;
          },
          { replace: true },
        )
      }
      onSaved={onSaved}
      onUse={onUse}
    />
  );
}
